import {
  Button,
  EmptyState,
  Flex,
  Input,
  SearchIcon,
} from '@buffer-mono/popcorn'

import type { Tag } from '~publish/hooks/useTags'

import { TagItem } from './TagItem'
import styles from '../Tags.module.css'

import type { JSX } from 'react'

interface TagsListProps {
  searchFilter: string
  onSearchChange: (value: string) => void
  filteredTags: Tag[]
  canManageTags: boolean
  onEditTag?: (tag: Tag) => void
}

export const TagsList = ({
  searchFilter,
  onSearchChange,
  filteredTags,
  canManageTags,
  onEditTag,
}: TagsListProps): JSX.Element => (
  <Flex direction="column" gap="sm" className={styles.content}>
    <Input
      prefix={<SearchIcon />}
      size="large"
      placeholder="Search tags..."
      value={searchFilter}
      onChange={(e) => onSearchChange(e.target.value)}
      className={styles.searchInput}
    />

    <Flex direction="column" gap="xs" fullWidth>
      {filteredTags.length === 0 ? (
        <EmptyState size="medium" className={styles.noResults}>
          <EmptyState.Icon>
            <SearchIcon />
          </EmptyState.Icon>
          <EmptyState.Heading size="small">No tags found</EmptyState.Heading>
          <EmptyState.Description>
            Try adjusting your search or clear the search to see all tags.
          </EmptyState.Description>
          <EmptyState.Actions>
            <Button onClick={() => onSearchChange('')}>Clear search</Button>
          </EmptyState.Actions>
        </EmptyState>
      ) : (
        filteredTags.map((tag) => (
          <TagItem
            key={tag.id}
            tag={tag}
            canManageTags={canManageTags}
            onEditTag={onEditTag}
          />
        ))
      )}
    </Flex>
  </Flex>
)
